// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import {getFirestore} from "firebase/firestore";
// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDQD9EFmNsnRubrVUcG7gDW4CriUTOr1R4",
    authDomain: "white-label-dev-2e5e0.firebaseapp.com",
    projectId: "white-label-dev-2e5e0",
    storageBucket: "white-label-dev-2e5e0.appspot.com",
    messagingSenderId: "933758799916",
    appId: "1:933758799916:web:03701f3faca910de434189"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 360;






